import React from 'react';

/**
 * Either given a React node (instance) or element class (function),
 * the method returns a wrapped node for a ready to mount icon.
 *
 * @param  {function|React node|null} IconComponent
 * @param  {String} className
 * @return {React Node} <div> wrapping the icon, null if null was passed.
 */
export default function createIcon(IconComponent, className = '', size = 21) {
    const iconElement =
        typeof IconComponent === 'function' ? <IconComponent width={size} height={size} /> : IconComponent;
    return iconElement ? (
        <div data-qa={'icon-element'} className={className}>
            {iconElement}
        </div>
    ) : null;
}

/**
 * Icon component
 * @param {Object} props
 */
export function Icon({ icon, iconClassName, size }) {
    return createIcon(icon, iconClassName, size);
}
